import React, { useState, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Collapse, Checkbox } from 'antd';
import { Button } from 'sections/Company/Faqs/SectionContent/Search/Button';
import 'antd/dist/antd.css';
import styles from 'sections/Company/Faqs/SectionContent/Search/Search.module.scss';

const cn = classNames.bind(styles);

interface ISearch {
  setSearchedValue: (event: any) => void;
  setSearchOptions: (event: any) => void;
  setIsSearching: (status: boolean) => void;
}

const Search = ({ setSearchedValue, setSearchOptions, setIsSearching }: ISearch): ReactElement => {
  const { Panel } = Collapse;
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedPanel, setIsOpenedPanel] = useState<any[]>([]);
  const [options, setOptions] = useState<any>({
    title: false,
    contents: false,
  });

  const [searchValue, setSearchValue] = useState<string>('');

  const checkboxOptions = [
    { id: 'title', label: 'title', value: 'title' },
    { id: 'contents', label: 'contents', value: 'contents' },
  ];

  const setCheckboxValue = (event: any) => {
    Object.keys(options).forEach((key) => {
      if (!key.includes(event.target.id)) {
        setOptions(() => {
          return {
            ...options,
            [event.target.id]: event.target.checked,
          };
        });
      } else {
        setOptions(() => {
          return {
            ...options,
            [event.target.id]: event.target.checked,
          };
        });
      }
    });
  };

  const cancelHandler = () => {
    setOptions(() => {
      return {
        ...options,
        title: false,
        contents: false,
      };
    });

    setIsOpened(false);
  };

  const saveHandler = () => {
    setOptions(options);
    setIsOpenedPanel(() => []);
  };

  const searchHandler = (event: any) => {
    event.preventDefault();
    setIsSearching(true);
    setSearchedValue(searchValue);
    setSearchOptions(options);
  };

  const keyPressHandler = (event: any) => {
    if (!event) return;
    if (event.key === 'Enter') {
      setIsSearching(true);
      setSearchedValue(searchValue);
      setSearchOptions(options);
    }
  };

  const setInputValue = (event: any) => {
    setSearchValue(event.target.value);
    setSearchedValue(event.target.value);
  };

  const clearHandler = () => {
    setSearchValue('');
    setSearchedValue('');
  };

  return (
    <div className={cn('search')}>
      <div className={cn('search__input-container')}>
        <svg
          className={cn('search__icon-magnifying-glass')}
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M13.9043 12.8215L10.5848 9.50195C10.5219 9.43906 10.4398 9.40625 10.3523 9.40625H9.99141C10.8527 8.4082 11.375 7.10938 11.375 5.6875C11.375 2.5457 8.8293 0 5.6875 0C2.5457 0 0 2.5457 0 5.6875C0 8.8293 2.5457 11.375 5.6875 11.375C7.10938 11.375 8.4082 10.8527 9.40625 9.99141V10.3523C9.40625 10.4398 9.4418 10.5219 9.50195 10.5848L12.8215 13.9043C12.95 14.0328 13.1578 14.0328 13.2863 13.9043L13.9043 13.2863C14.0328 13.1578 14.0328 12.95 13.9043 12.8215ZM5.6875 10.0625C3.27031 10.0625 1.3125 8.10469 1.3125 5.6875C1.3125 3.27031 3.27031 1.3125 5.6875 1.3125C8.10469 1.3125 10.0625 3.27031 10.0625 5.6875C10.0625 8.10469 8.10469 10.0625 5.6875 10.0625Z"
            fill="#C9CFDB"
          />
        </svg>

        <input
          className={cn('search__input')}
          id="search"
          name="search"
          type="text"
          placeholder="Search help articles ..."
          value={searchValue}
          onChange={setInputValue}
          //@ts-ignore
          onKeyPress={keyPressHandler}
        />

        {searchValue && (
          <svg
            className={cn('search__icon-cross')}
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="times-circle"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            onClick={clearHandler}
          >
            <path
              fill="currentColor"
              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
              className=""
            />
          </svg>
        )}

        <div className={cn('filter')}>
          {/*//@ts-ignore*/}
          <Collapse
            accordion
            ghost
            activeKey={isOpenedPanel}
            defaultActiveKey={[0]}
            onChange={() => {
              setIsOpenedPanel((prev) => (prev.length ? [] : [1]));
            }}
          >
            {/*//@ts-ignore*/}
            <Panel
              key={1}
              showArrow={false}
              //@ts-ignore
              onChange={() => setIsOpenedPanel([0])}
              header={
                <svg
                  className={cn('filter__icon')}
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M9.97456 11.8869H7.93582C7.80065 11.8869 7.67101 11.9406 7.57542 12.0362C7.47984 12.1318 7.42614 12.2614 7.42614 12.3966V12.9063C7.42614 13.0415 7.47984 13.1711 7.57542 13.2667C7.67101 13.3623 7.80065 13.416 7.93582 13.416H9.97456C10.1097 13.416 10.2394 13.3623 10.335 13.2667C10.4305 13.1711 10.4842 13.0415 10.4842 12.9063V12.3966C10.4842 12.2614 10.4305 12.1318 10.335 12.0362C10.2394 11.9406 10.1097 11.8869 9.97456 11.8869ZM5.51482 12.1418H4.11319V1.43839C4.11319 1.30322 4.0595 1.17358 3.96391 1.07799C3.86833 0.98241 3.73869 0.928711 3.60351 0.928711H3.09383C2.95865 0.928711 2.82901 0.98241 2.73343 1.07799C2.63784 1.17358 2.58414 1.30322 2.58414 1.43839V12.1418H1.18251C1.10782 12.1417 1.03475 12.1636 0.972335 12.2046C0.909919 12.2456 0.86089 12.304 0.831308 12.3726C0.801725 12.4412 0.792884 12.517 0.805877 12.5905C0.81887 12.6641 0.853128 12.7322 0.904417 12.7865L3.07057 15.0801C3.1063 15.1179 3.14936 15.148 3.19712 15.1685C3.24489 15.1891 3.29635 15.1997 3.34835 15.1997C3.40036 15.1997 3.45181 15.1891 3.49958 15.1685C3.54734 15.148 3.5904 15.1179 3.62613 15.0801L5.79228 12.7865C5.84354 12.7322 5.87778 12.6642 5.8908 12.5907C5.90381 12.5172 5.89502 12.4415 5.86552 12.3729C5.83602 12.3044 5.78709 12.2459 5.72477 12.2049C5.66245 12.1638 5.58946 12.1418 5.51482 12.1418ZM14.052 5.77071H7.93582C7.80065 5.77071 7.67101 5.82441 7.57542 5.91999C7.47984 6.01557 7.42614 6.14521 7.42614 6.28039V6.79007C7.42614 6.92525 7.47984 7.05489 7.57542 7.15047C7.67101 7.24606 7.80065 7.29976 7.93582 7.29976H14.052C14.1872 7.29976 14.3168 7.24606 14.4124 7.15047C14.508 7.05489 14.5617 6.92525 14.5617 6.79007V6.28039C14.5617 6.14521 14.508 6.01557 14.4124 5.91999C14.3168 5.82441 14.1872 5.77071 14.052 5.77071ZM16.0908 2.7126H7.93582C7.80065 2.7126 7.67101 2.7663 7.57542 2.86189C7.47984 2.95747 7.42614 3.08711 7.42614 3.22229V3.73197C7.42614 3.86715 7.47984 3.99679 7.57542 4.09237C7.67101 4.18796 7.80065 4.24166 7.93582 4.24166H16.0908C16.2259 4.24166 16.3556 4.18796 16.4512 4.09237C16.5467 3.99679 16.6004 3.86715 16.6004 3.73197V3.22229C16.6004 3.08711 16.5467 2.95747 16.4512 2.86189C16.3556 2.7663 16.2259 2.7126 16.0908 2.7126ZM12.0133 8.82881H7.93582C7.80065 8.82881 7.67101 8.88251 7.57542 8.97809C7.47984 9.07368 7.42614 9.20332 7.42614 9.33849V9.84818C7.42614 9.98335 7.47984 10.113 7.57542 10.2086C7.67101 10.3042 7.80065 10.3579 7.93582 10.3579H12.0133C12.1485 10.3579 12.2781 10.3042 12.3737 10.2086C12.4693 10.113 12.523 9.98335 12.523 9.84818V9.33849C12.523 9.20332 12.4693 9.07368 12.3737 8.97809C12.2781 8.88251 12.1485 8.82881 12.0133 8.82881Z"
                    fill="currentColor"
                  />
                </svg>
              }
            >
              <div
                className={cn('filter__dropdown', { 'is-closed': isOpened } )}
              >
                <div className={cn('filter__heading')}>
                  <span>search by</span>
                </div>
                <div className={cn('filter__options')}>
                  <Checkbox
                    id="title"
                    //@ts-ignore
                    options={checkboxOptions}
                    onChange={setCheckboxValue}
                    checked={options.title}
                  >
                    title
                  </Checkbox>
                  <Checkbox
                    id="contents"
                    //@ts-ignore
                    options={checkboxOptions}
                    onChange={setCheckboxValue}
                    checked={options.contents}
                  >
                    contents
                  </Checkbox>
                </div>
                <div className={cn('filter__buttons')}>
                  <Button
                    name="buttonCancel"
                    action={cancelHandler}
                    buttonStyles={{
                      backgroundColor: '#ffffff',
                      color: '#0C1840',
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    name="buttonSave"
                    action={saveHandler}
                    buttonStyles={{
                      backgroundColor: '#0C1840',
                      color: '#ffffff',
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>
      <div className={cn('search__buttons-box')}>
        <Button
          name="buttonSearch"
          action={searchHandler}
          buttonStyles={{
            height: '48px',
            backgroundColor: '#0C1840',
            color: '#ffffff',
          }}
        >
          Search
        </Button>
      </div>
    </div>
  );
};

export { Search };
